import React from 'react';

/**
 * Attributed quote block.
 *
 * Treatment from the design reference
 * (docs/revamp-july-2026/handoff/Focal Point Site.dc.html, proof section):
 * --sand-2 field, 3px --ink-blue left rule, 4px radius, 30px/32px padding,
 * quote at 22px Outfit 400 leading 1.42, attribution at 13px Public Sans
 * uppercase with 0.12em tracking in --text-3.
 *
 * Extracted rather than inlined because it has three consumers on the homepage
 * alone: the founder pull quote and the two testimonial cards.
 *
 * `attribution` is optional so the same component carries the founder pull
 * quote, which is Tim's own voice and therefore unattributed.
 */

interface QuoteCardProps {
  quote: string;
  attribution?: string;
  className?: string;
}

export default function QuoteCard({ quote, attribution, className = '' }: QuoteCardProps) {
  return (
    <blockquote
      className={`rounded border-l-[3px] border-ink-blue bg-sand-2 px-6 py-7 md:px-8 md:py-[30px] ${className}`.trim()}
    >
      <p className="font-display text-xl leading-[1.42] tracking-[-0.015em] text-ink text-pretty md:text-[22px]">
        {quote}
      </p>
      {attribution ? (
        <footer className="pt-3.5 font-sans text-[13px] uppercase tracking-[0.12em] text-caption">
          {attribution}
        </footer>
      ) : null}
    </blockquote>
  );
}
